var $ = require('jquery');

$(function () {

    $(".reset-password__body__step1--submit")
            .on("click", function (e) {
                e.preventDefault();
                
                var isValid = true;
                var formNode = $(this).closest("form");
                var formId = formNode.attr("id");
                var itemid = formNode.find("input[name=ItemID]");
                var contextLang = formNode.attr("data-contextLang");
                var email = formNode.find("input[name=Email]");
                var payload = [];
                var textValue = email.val();

                setValidationErrorMessage(formNode, false);
                setInvalid(email, false, 'form__field--has-error--invalid');

                if (textValue.length === 0 || !isEmail(textValue))
                {
                    setInvalid(email, true, 'form__field--has-error--invalid');
                }
                else
                {
                    setInvalid(email, false, 'form__field--has-error--invalid');

                    console.log(itemid.val());
                    $.ajax({
                        url: "/api/Sitecore/ProfileManagement/ResetPassword",
                        type: "POST",
                        context: this,
                        contentType: "application/json",
                        data: JSON.stringify({
                            itemID: itemid.val(),
                            email: email.val()
                        }),
                        success: function (data) {
                            if (data) {
                                setValidationErrorMessage(formNode, false);

                                if (data.requiresQuestionAndAnswer &&
                                    data.passwordQuestion !== undefined &&
                                    data.passwordQuestion !== '') {
                                    $("label[for='PasswordAnswer']").text(data.passwordQuestion);
                                    goto(formNode, 'reset-password__body__step2');
                                }
                                else {
                                    if (data.emailSent) {
                                        goto(formNode, 'reset-password__body__step3');
                                    }
                                    else {
                                        goto(formNode, 'reset-password__body__step3');
                                    }
                                } 
                            }
                            else
                            {
                                handleError(formNode, email);
                            }
                        },
                        error: function (jqXHR, status, error) {
                            handleError(formNode, email, jqXHR, status, error);
                        }

                    });
                }
            });

    $(".reset-password__body__step2--submit")
            .on("click", function (e) {
                e.preventDefault();

                var isValid = true;
                var formNode = $(this).closest("form");
                var itemid = formNode.find("input[name=ItemID]");
                var email = formNode.find("input[name=Email]");
                var passwordAnswer = formNode.find("input[name=PasswordAnswer]");
                var payload = [];
                var textValue = passwordAnswer.val();

                setValidationErrorMessage(formNode, false);
                setInvalid(passwordAnswer, false, 'form__field--has-error--invalid');

                if (textValue.length === 0) {
                    setInvalid(passwordAnswer, true, 'form__field--has-error--invalid');
                }
                else {
                    setInvalid(passwordAnswer, false, 'form__field--has-error--invalid');

                    $.ajax({
                        url: "/api/Sitecore/ProfileManagement/ResetPasswordPasswordAnswer",
                        type: "POST",
                        context: this,
                        contentType: "application/json",
                        data: JSON.stringify({
                            itemID: itemid.val(),
                            email: email.val(),
                            passwordAnswer: passwordAnswer.val()
                        }),
                        success: function (data) {
                            if (data) {
                                if (data.emailSent) {
                                    goto(formNode, 'reset-password__body__step3');
                                }
                                else {
                                    goto(formNode, 'reset-password__body__step3');
                                    handleError(formNode, passwordAnswer);
                                }
                            } else {
                                goto(formNode, 'reset-password__body__step1');
                                handleError(formNode, passwordAnswer);
                            }
                        },
                        error: function (jqXHR, status, error) {
                            handleError(formNode, domElement, jqXHR, status, error);  
                        }
                    });
                }
            });

    $(".reset-password__body__step4--submit")
            .on("click", function (e) {
                e.preventDefault();

                var isValid = true;
                var formNode = $(this).closest("form");
                var itemid = formNode.find("input[name=ItemID]");
                var email = formNode.find("input[name=Email]");
                var password = formNode.find("input[name=Password]");
                var passwordConfirm = formNode.find("input[name=PasswordConfirm]");
                var passwordToken = formNode.find("input[name=PasswordToken]");
                var payload = [];

                setValidationErrorMessage(formNode, false);
                setInvalid(password, false, 'form__field--has-error--invalid');
                
                if (password.val().trim() == '' || password.val() != passwordConfirm.val()) {
                    setInvalid(password, true, 'form__field--has-error--invalid');
                }
                else {
                    setInvalid(password, false, 'form__field--has-error--invalid');

                    $.ajax({
                        url: "/api/Sitecore/ProfileManagement/ResetPassword",
                        type: "POST",
                        context: this,
                        contentType: "application/json",
                        data: JSON.stringify({
                            itemID: itemid.val(),
                            email: email.val(),
                            passwordToken: passwordToken.val(),
                            password: password.val(),
                            passwordConfirm: passwordConfirm.val(),

                        }),
                        success: function (data) {
                            if (data) {
                                if (data.passwordUpdated) {
                                    goto(formNode, 'reset-password__body__step5');
                                }
                                else {
                                    goto(formNode, 'reset-password__body__step4');
                                    setInvalid(password, true, 'form__field--has-error--invalid');
                                }
                            } else {
                                goto(formNode, 'reset-password__body__step4');
                                setInvalid(password, true, 'form__field--has-error--invalid');
                            }
                        },
                        error: function (jqXHR, status, error) {
                            handleError(formNode, domElement, jqXHR, status, error);
                        }
                    });
                }
            });
    function goto(formNode, next)
    {
        formNode.find(".reset-password__body__step")
            .each(function () {
                var $this = $(this);
                var current = ($this.hasClass(next)) ? $this : undefined;

                $this.hide();

                if(current !== undefined)
                {
                    current.show();
                }
            });
    }

    function setInvalid(field, invalid, customClass)
    {
        if (invalid)
        {
            field.parent().addClass('form__field--has-error');
            if (customClass)
                field.parent().addClass(customClass);
            field.focus();
            field.select();
        }
        else
        {
            field.parent().removeClass('form__field--has-error');
            if (customClass)
                field.parent().removeClass(customClass);
        }
    }

    function setValidationErrorMessage(formNode, isInvalid) {
        if (formNode !== undefined) {
            if (isInvalid) {
                formNode.find(".validation-summary-valid")
                    .each(function () {
                        var $this = $(this);

                        $this.removeClass('validation-summary-valid');
                        $this.addClass('validation-summary-errors');
                    });
            }
            else {
                formNode.find(".validation-summary-errors")
                    .each(function () {
                        var $this = $(this);

                        $this.removeClass('validation-summary-errors');
                        $this.addClass('validation-summary-valid');
                    });
            }
        }
    }

    function checkInvalid(domElement, isRequired, secondaryValidator, errorSelector) {
        if (isRequired && secondaryValidator) {
            isValid = false;
            $(domElement).attr('data-isInvalid', 'true');
            if (!!errorSelector) {
                if ($(domElement).attr('data-is-invalid-selector')) {
                    $(domElement).attr('data-is-invalid-selector', $(domElement).attr('data-is-invalid-selector') + ',' + errorSelector);
                } else {
                    $(domElement).attr('data-is-invalid-selector', errorSelector);
                }
            }
        }
    }

    function handleError(formNode, formField, jqXHR, status, error) {
        setValidationErrorMessage(formNode, true);
        setInvalid(formField, true);

        console.log(jqXHR);
        console.log(status)
        console.error(error);
    }

    function isEmail(email) {
        var regex =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
    }

    $('.reset-password__field').keyup(function (e) {
        if (event.keyCode == 13) {
            $(this).closest('.reset-password__body__step').find('.submit-button').click();
        }
    });

    $('form').keyup(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
        }
    });
})